import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { Modal, ModalFooter } from '@lightspeed/flame/Modal';

export const StyledModal = styled(Modal)`
  max-width: 600px;
  width: 600px;
`;

export const StyledModalFooter = styled(ModalFooter)`
  display: flex;
  justify-content: flex-end;
`;

export const StyledModalLoading = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
